/**
 * 자료실 페이지 정의. 4개 페이지(회칙/의결기구/예·결산/양식)는 카테고리 구성만
 * 다르고 동작이 동일하므로 이 config로 환원한다.
 *
 * - pageName: 상단 헤더 문구
 * - editSlug: 상세/수정 라우트 슬러그 (/dataCollection/<editSlug>/:id)
 * - categories: 탭이자 등록 카테고리. 길이 1이면 탭 바를 그리지 않는다.
 *   각 항목의 id는 서버 shareNotices의 category 값.
 */
export const DATA_COLLECTION_CONFIGS = {
  bylaws: {
    pageName: "자료실 - 회칙",
    editSlug: "bylaws",
    categories: [
      { id: 1, label: "집행기구" },
      { id: 2, label: "자치기구" },
      { id: 3, label: "전문기구" },
      { id: 4, label: "협의기구" },
      { id: 5, label: "특별대표기구" },
      { id: 6, label: "특별기구" },
    ],
  },
  votingBody: {
    pageName: "자료실 - 의결기구",
    editSlug: "votingBody",
    categories: [
      { id: 8, label: "회의록 / 의결결과" },
      { id: 7, label: "자료집" },
    ],
  },
  budget: {
    pageName: "자료실 - 예/결산",
    editSlug: "budget",
    categories: [
      { id: 9, label: "예산안/추가경정안" },
      { id: 10, label: "결산안" },
    ],
  },
  other: {
    pageName: "자료실 - 양식",
    editSlug: "other",
    categories: [{ id: 11, label: "양식" }],
  },
};
